import { useEffect, useState } from "react";
import { getProfile, updateProfile } from "../../services/profileService";

export default function EditProfile() {
  const [form, setForm] = useState({
    fullName: "",
    nickName: "",
    gender: "",
    age: "",
    mobileNumber: "",
    country: "",
    descriptionOfChannel: "",
    subscriptionCost: "",
    videoUnlockCost: "",
    instagramLink: "",
    facebookLink: "",
    twitterLink: "",
    websiteLink: "",
  });

  const [loading, setLoading] = useState(false);

  // Load Existing Data
  useEffect(() => {
    const loadProfile = async () => {
      try {
        const data = await getProfile();

        if (data.status) {
          const user = data.user;

          setForm({
            fullName: user.fullName || "",
            nickName: user.nickName || "",
            gender: user.gender || "",
            age: user.age || "",
            mobileNumber: user.mobileNumber || "",
            country: user.country || "",
            descriptionOfChannel: user.descriptionOfChannel || "",
            subscriptionCost: user.subscriptionCost || "",
            videoUnlockCost: user.videoUnlockCost || "",
            instagramLink: user.socialMediaLinks?.instagramLink || "",
            facebookLink: user.socialMediaLinks?.facebookLink || "",
            twitterLink: user.socialMediaLinks?.twitterLink || "",
            websiteLink: user.socialMediaLinks?.websiteLink || "",
          });
        }
      } catch (err) {
        console.error("Load profile error:", err);
      }
    };

    loadProfile();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = await updateProfile(form);

      if (data.status) {
        alert("Profile updated successfully!");
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    }

    setLoading(false);
  };

  return (
    <div className="profile-card">
      <h3>Edit Profile</h3>

      <form onSubmit={handleSubmit} className="edit-form">

        <div className="form-grid">

          <input
            type="text"
            name="fullName"
            placeholder="Full Name"
            value={form.fullName}
            onChange={handleChange}
          />

          <input
            type="text"
            name="nickName"
            placeholder="Nick Name"
            value={form.nickName}
            onChange={handleChange}
          />

          <select
            name="gender"
            value={form.gender}
            onChange={handleChange}
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>

          <input
            type="number"
            name="age"
            placeholder="Age"
            value={form.age}
            onChange={handleChange}
          />

          <input
            type="text"
            name="mobileNumber"
            placeholder="Mobile Number"
            value={form.mobileNumber}
            onChange={handleChange}
          />

          <input
            type="text"
            name="country"
            placeholder="Country"
            value={form.country}
            onChange={handleChange}
          />

          <input
            type="number"
            name="subscriptionCost"
            placeholder="Subscription Cost (Coins)"
            value={form.subscriptionCost}
            onChange={handleChange}
          />

          <input
            type="number"
            name="videoUnlockCost"
            placeholder="Video Unlock Cost (Coins)"
            value={form.videoUnlockCost}
            onChange={handleChange}
          />

        </div>

        <textarea
          name="descriptionOfChannel"
          placeholder="Channel Description"
          value={form.descriptionOfChannel}
          onChange={handleChange}
          rows={4}
        />

        <h4>Social Links</h4>

        <div className="form-grid">

          <input
            type="text"
            name="instagramLink"
            placeholder="Instagram Link"
            value={form.instagramLink}
            onChange={handleChange}
          />

          <input
            type="text"
            name="facebookLink"
            placeholder="Facebook Link"
            value={form.facebookLink}
            onChange={handleChange}
          />

          <input
            type="text"
            name="twitterLink"
            placeholder="Twitter Link"
            value={form.twitterLink}
            onChange={handleChange}
          />

          <input
            type="text"
            name="websiteLink"
            placeholder="Website Link"
            value={form.websiteLink}
            onChange={handleChange}
          />

        </div>

        <button type="submit" disabled={loading}>
          {loading ? "Updating..." : "Update Profile"}
        </button>

      </form>
    </div>
  );
}
